<template>
    <el-container style="height: 100%">
        <el-header style="height: 30px">
            <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="historyBack"/>
        </el-header>
        <el-main>
            <el-form ref="form" :model="staffChange" label-width="80px" :rules="rules" style="padding: 20px" size="mini">
                <el-form-item label="单号" prop="sysbillid">
                    {{staffChange.sysbillid}}
                </el-form-item>
                <el-form-item label="员工姓名" prop="staffname">
                    <el-input v-model="staffChange.staffname" readonly></el-input>
                </el-form-item>
                <el-form-item label="原职位" prop="posname">
                    <el-input v-model="staffChange.posname" readonly></el-input>
                </el-form-item>
                <el-form-item label="新职位" prop="newposid">
                    <el-select v-model="staffChange.newposid" style="width: 100%">
                        <el-option :label="item.constantname" :value="item.constantid" :key="key" v-for="(item,key) in posData"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="调整日期" prop="changedate">
                    <el-date-picker v-model="staffChange.changedate" type="date" placeholder="选择日期" class="data-picker" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="loading" @click="staffPosChange" style="width: 100%">保存</el-button>
                </el-form-item>
            </el-form>
        </el-main>
    </el-container>
</template>

<script>
export default {
    data() {
        return {
            rules:{
                newposid: [
                    {required: true, message: "请选择新职位", trigger: 'blur'},
                ],
                changedate: [
                    {required: true, message: "请选择调整日期", trigger: 'blur'},
                ],
            },
            loading:false,
            posData:[],
            staffChange: {
                staffname:"",
                posname:"",
                storeid:"",
                staffid:"",
                sysbillid:"",
                oldstoreid:"",
                olddeptid:"",
                oldposid:"",
                oldmanagerposid:"",
                oldrankid:"",
                oldstaffnumber:"",
                oldbasesalary:"",
                newstoreid:"",
                newdeptid:"",
                newposid:"",
                newmanagerposid:"",
                newrankid:"",
                newstaffnumber:"",
                newbasesalary:0,
                changedate:"",
                createdate:"",
                creator:"",
                creatorname:"",
                quittype:1,
                changetype:4
            },
            title:"职位调整",
        }
    },
    created() {
        let staffid=this.$route.query.staffid;
        let type=this.$route.query.type;
        if(type==3){
            this.title="重回公司";
        }
        if(staffid) {
            this.staffChange.changetype=type;
            this.getInteboStaffById(staffid);
            this.getSysBillId();
            this.getPosData();
        }
    },
    methods:{
        getSysBillId(){
            this.$post("product/getSysBillId").then(res=>{
                if(res.sucess){
                    this.staffChange.sysbillid=res.object;
                }
            });
        },
        getPosData(){
            this.$post("basis/getConstantInfo",{storeid:"320c07ba76e94b0d8735aefe4470c07a",constanttype:"YTBZW",lv:2,status:0,guid:""}).then(res=>{
                if(res.sucess){
                    this.posData=res.object;
                }
            });
        },
        staffPosChange(){
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    this.loading=true;
                    this.$postw("inteboStaff/staffPosChange",this.staffChange).then(res=>{
                        this.loading=false;
                        if(res.sucess) {
                            this.$message({message: "保存成功", type: 'success'});
                            this.$router.push('/staffinfo');
                        }
                    });
                }
            });
        },
        getInteboStaffById(staffid){
            this.$post("inteboStaff/getInteboStaffById",{staffid:staffid}).then(res=>{
                if(res.sucess){
                    let staff=res.object;
                    this.staffChange.storeid=staff.storeid;
                    this.staffChange.oldstoreid=staff.storeid;
                    this.staffChange.newstoreid=staff.storeid;
                    this.staffChange.staffid=staff.staffid;
                    this.staffChange.staffname=staff.staffname;
                    this.staffChange.posname=staff.posname;
                    this.staffChange.oldstaffnumber=staff.phone;
                    this.staffChange.newstaffnumber=staff.phone;
                    this.staffChange.olddeptid="32";
                    this.staffChange.newdeptid="32";
                    this.staffChange.oldposid=staff.posid;
                    this.staffChange.creator=localStorage.getItem("staffid");
                    this.staffChange.creatorname=localStorage.getItem("staffname");
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/page/intebo/intebostaff/staffposchange.vue